import { SegmentedControl } from '@ardoq/button';
import { IconName } from '@ardoq/icons';
import { type I18nLocale, t } from '@ardoq/i18n';
import type { InventoryDatasourceSelection } from '../types';

type HierarchySwitchProps = {
  isHierarchyEnabled: boolean;
  datasourceSelection: InventoryDatasourceSelection;
  onToggleHierarchy: (
    shouldEnableHierarchy: boolean,
    datasourceSelection: InventoryDatasourceSelection
  ) => Promise<void>;
  i18nLocale: I18nLocale;
};

const getViewToggleItems = (i18nLocale: I18nLocale) => [
  {
    id: 'listView',
    label: t(i18nLocale, 'inventory:interactiveRow.listView', 'List'),
    icon: IconName.FORMAT_LIST_BULLETED,
  },
  {
    id: 'hierarchyView',
    label: t(i18nLocale, 'inventory:interactiveRow.hierarchyView', 'Hierarchy'),
    icon: IconName.TREE_STRUCTURE,
  },
];

export const HierarchySwitch = ({
  isHierarchyEnabled,
  datasourceSelection,
  onToggleHierarchy,
  i18nLocale,
}: HierarchySwitchProps) => (
  <SegmentedControl
    items={getViewToggleItems(i18nLocale)}
    selectedId={isHierarchyEnabled ? 'hierarchyView' : 'listView'}
    onSelectionChange={id =>
      onToggleHierarchy(id === 'hierarchyView', datasourceSelection)
    }
    variant="icon-only"
    aria-label={t(
      i18nLocale,
      'inventory:interactiveRow.viewModeAriaLabel',
      'View mode'
    )}
  />
);
